import React from 'react';
import pt from 'prop-types';
import currency from 'currency.js';
import { useMutation } from '@tanstack/react-query';
import retouchingImg from '../../assets/Retouching_Graphic.png';
import useRetouchingExtra from '../../hooks/useRetouchingExtra';
import styles from './Retouching.module.scss';
import Button from '../Button/v2';
import useOrderPackage from '../../hooks/useOrderPackage';

export default function Retouching({ onAccept, onDecline, orderPackageId }) {
  const { data: orderPackage } = useOrderPackage(orderPackageId);
  const { data: retouching } = useRetouchingExtra();
  const { mutate, isLoading } = useMutation({
    mutationFn: () => {
      orderPackage.extras = [...orderPackage.extras, retouching];

      return orderPackage.save({ with: 'extras' });
    },
    onSuccess: () => {
      if (Object.keys(orderPackage.errors).length > 0) return;

      onAccept();
    },
  });

  if (!retouching) return null;
  if (!orderPackage) return null;
  if (orderPackage.cart.purchased) return null;

  return (
    <div className={styles.container}>
      <img alt="Retouching" className={styles.img} src={retouchingImg} />
      <div className={styles.contentWrapper}>
        <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
          <h1 className={styles.title} style={{ marginBottom: '1rem' }}>Professional Retouching</h1>
          <p style={{ fontWeight: 'bold' }}>Add the finishing touch to your portraits!</p>
          <p className={styles.includeMsg}>Retouching includes:</p>
          <p>Skin smoothing & Blemish removal</p>
        </div>
        <div className={styles.btnsContainer}>
          <Button onClick={mutate} disabled={isLoading}>ADD RETOUCHING - {currency(retouching.prices[0].price).format()}</Button>
          <Button variant="" onClick={onAccept}>Continue to Checkout</Button>
        </div>
      </div>
    </div>
  );
}

Retouching.propTypes = {
  onAccept: pt.func.isRequired,
  onDecline: pt.func.isRequired,
  orderPackageId: pt.oneOfType([pt.string, pt.number]).isRequired,
};
